// src/components/ui/checkbox.jsx
import React from 'react'

export const Checkbox = ({ checked, onCheckedChange, className = '', ...props }) => {
  return (
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onCheckedChange?.(e.target.checked)}
      className={className}
      {...props}
    />
  )
}
